// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function TableHead(theme) {
  return {
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: theme.vars.palette.grey[200],
          borderBottom: `1px solid ${theme.vars.palette.divider}`,
          '& .MuiTableCell-root': {
            color: theme.vars.palette.text.primary,
            fontWeight: 800,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            fontSize: '0.75rem'
          }
        }
      }
    }
  };
}
